import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { EmployeeFirstOfKin } from './../models/employeeFirstOfKin';
import { EmployeeFirstOfKinServices } from './employeefirstofkin.service';

@Injectable()
export class FirstOfKinListResolver {
    constructor(private backend: EmployeeFirstOfKinServices) {}
    resolve(route: ActivatedRouteSnapshot): Observable<EmployeeFirstOfKin[]> {
        return this.backend.getByBusiness();
    }
}

